import { styled } from 'twin.macro'

export const Wrapper = styled.div``
